<template>
  <main
    class="main-content position-relative max-height-vh-100 h-100 border-radius-lg d-flex"
  >
    <div class="main-wrapper flex-grow-1" :style="sidenavMarginStyle">
      <link
        href="https://fonts.googleapis.com/css?family=Impact"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Noto+Sans+JP"
        rel="stylesheet"
      />
      <router-view />
      <div
        v-if="this.isDeepResearchProcessing"
        class="loading-deep-research"
        :class="{ 'is-complete': this.isDeepResearchComplete }"
      >
        <img
          :src="require('@/assets/img/auth/MI-chao_logo_icon.png')"
          class="mi-chao-icon"
          alt="Logo"
        />
        <div class="loading-text">
          {{
            this.isDeepResearchComplete
              ? '答え見つけてきたにゃん！'
              : 'いい答えを探してるにゃん'
          }}
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import HTTPService from '@/services/HTTPService'
import { useAuthStore } from '@/store/auth'
//import { initAuthChannel } from '@/services/AuthChannelService'

export default {
  name: 'App',
  data() {
    return {
      windowWidth: window.innerWidth,
      pollingTimer: null,
      isDeepResearchProcessing: false,
      isDeepResearchComplete: false,
    }
  },
  computed: {
    ...mapState([
      'isTransparent',
      'isRTL',
      'isNavFixed',
      'isAbsolute',
      'navbarFixed',
      'absolute',
      'color',
      'showSidenav',
      'showNavbar',
      'showFooter',
      'showConfig',
      'hideConfigButton',
      'isSidenavOpen',
    ]),

    computedShowNavbar() {
      return this.$route.meta.showNavbar !== undefined
        ? this.$route.meta.showNavbar
        : this.showNavbar
    },

    sidenavMarginStyle() {
      // メンテナンス
      const isMaintenancePage = this.$route.name?.includes('Maintenance')
      // ログイン
      const isLoginPage = this.$route.name?.includes('Login')
      // 相談しチャオ
      const isBasicChatPage = this.$route.name?.includes('BasicChat')
      // 検索しチャオ
      const isSearchChatPage = this.$route.name?.includes('SearchChat')
      // RAGっチャオ
      const isRagChat = this.$route.name?.includes('RagChat')
      // 議事録っチャオ
      const isSummaryPage = this.$route.name?.includes('Summary')
      // 翻訳しチャオ
      const isTranslationPage = this.$route.name?.includes('Translation')
      // 画像/PDFテキスト化
      const isExtractTextPage = this.$route.name?.includes('ExtractText')
      // テキスト化しチャオ
      const isOCR = this.$route.name?.includes('OCR')
      // 画像生成しチャオ
      const isImageGenerationPage =
        this.$route.name?.includes('ImageGeneration')
      // RAGチャットの設定
      const isChatBotSettingPage = this.$route.name?.includes('ChatBotSetting')

      // 課、部署のRAGっチャオ小部屋
      const isTenantRagChatPage = this.$route.name?.includes('TenantRagChat')
      const isTenantControlPanelPage = this.$route.name === 'TenantControlPanel'
      const isTenantControlPanelConfirmPage = this.$route.name?.includes(
        'TenantControlPanelConfirm',
      )

      const isMobile = this.windowWidth < 992

      if (
        isMaintenancePage ||
        isLoginPage ||
        isExtractTextPage ||
        isTranslationPage ||
        isSearchChatPage ||
        isChatBotSettingPage ||
        isTenantControlPanelPage ||
        isMobile ||
        isOCR
      )
        return {}

      let marginLeft = '250px'
      if (
        isBasicChatPage ||
        isRagChat ||
        isSummaryPage ||
        isImageGenerationPage ||
        isTenantRagChatPage ||
        isTenantControlPanelConfirmPage
      )
        marginLeft = '250px'
      //if (isSummaryPage) marginLeft = '322px'

      return {
        marginLeft: this.isSidenavOpen ? marginLeft : '40px',
        transition: 'margin-left 0.3s ease',
      }
    },
  },
  mounted() {
    this.updateSidenavState()
    window.addEventListener('resize', this.handleResize)

    this.setVhVariable()

    //initAuthChannel()

    this.checkAndControlPolling()

    // 画面の向きが変わったときに再計算
    window.addEventListener('orientationchange', () => {
      setTimeout(this.setVhVariable, 300)
    })
  },
  beforeUnmount() {
    this.stopPolling()
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    ...mapMutations(['toggleConfigurator', 'navbarMinimize']),

    updateSidenavState() {
      this.$store.commit('setMobileState', this.windowWidth < 992)
      this.$store.commit('setSidenavState', this.windowWidth >= 992)
    },

    handleResize() {
      this.windowWidth = window.innerWidth
      this.updateSidenavState()
    },

    setVhVariable() {
      if (this.windowWidth < 992) {
        const vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      }
    },

    async fetchStatus() {
      try {
        const auth = useAuthStore()
        if (auth.token) {
          const res = await HTTPService.get_conversation_status()
          this.isDeepResearchProcessing = res.data.is_processing
          this.isDeepResearchComplete = res.data.is_complete

          this.$store.commit('updateConversationStatus', res.data)
          this.$store.commit('updateProcessing', this.isDeepResearchProcessing)

          // ★ 状態に応じて制御
          if (this.isDeepResearchProcessing) {
            this.startPolling()
          } else {
            this.stopPolling()
          }
        }
      } catch (e) {
        console.error(e)
        this.stopPolling()
      }
    },

    // -------------------------
    // ポーリング開始
    // -------------------------
    startPolling() {
      // 既に動いてたら何もしない
      if (this.pollingTimer) return

      console.log('▶ polling start')

      this.pollingTimer = setInterval(() => {
        this.fetchStatus()
      }, 10000)
    },

    // -------------------------
    // ポーリング停止
    // -------------------------
    stopPolling() {
      if (this.pollingTimer) {
        console.log('■ polling stop')
        clearInterval(this.pollingTimer)
        this.pollingTimer = null
      }
    },

    // -------------------------
    // 初期チェック
    // -------------------------
    async checkAndControlPolling() {
      await this.fetchStatus()
    },
  },
  watch: {
    // -------------------------
    // ★ Deep Research開始時に呼ぶ
    // -------------------------
    '$store.state.triggerPolling': {
      handler(val) {
        if (val) {
          this.startPolling()
          this.$store.commit('updateTriggerPolling', false)
        }
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
.main-wrapper {
  transition: margin 0.3s ease;
}
</style>
